import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=0885fa21&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=0885fa21&prod&scoped=true&lang=scss&"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=0885fa21&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../1013/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0885fa21",
  null
  
)

export default component.exports